import { locale } from "../locale"

/**
 * @param {FarmcamSim} fcs 
 * @returns {string}
 */
function checkRemainingData(fcs) {
    if (Date.now() > new Date(fcs.Subscription.ExpiresAt).getTime()) return ""

    if (fcs.RemainingData < 1)
        return locale.string({
            enGB: "Out of data",
            deDE: "Keine Daten mehr vorhanden",
            frFR: "Données manquantes",
            svSE: "Slut på data",
        })

    if (fcs.RemainingData < 20e6)
        return locale.string({
            enGB: "Low data",
            deDE: "Niedrige Daten",
            frFR: "Peu de données",
            svSE: "Låg data",
        })

    return ""
}

/**
 * @param {FarmcamSim} fcs 
 * @returns {string[]}
 */
function getFarmcamSimWarnings(fcs) {
    return [
        checkRemainingData(fcs),
    ].filter(text => text !== "")
}


export {
    getFarmcamSimWarnings
}
